import { FC, HTMLProps, PropsWithChildren } from 'react';
import {
  SummaryList,
} from 'nhsuk-react-components';

import 'components/HighlightedTable/HighlightedTable.scss';

type TableHeaderRowProps = PropsWithChildren & HTMLProps<HTMLDivElement>;
function TableHeaderRow({ children, ...rest }: TableHeaderRowProps) {
  return (
    <SummaryList.Row className="header-row" {...rest}>
      {children}
    </SummaryList.Row>
  );
}

type TableHeaderValueProps = PropsWithChildren & HTMLProps<HTMLDListElement>;
function TableHeaderValue({ children, ...rest }: TableHeaderValueProps) {
  return <SummaryList.Value {...rest}>{children}</SummaryList.Value>;
}

type TableRowProps = PropsWithChildren & HTMLProps<HTMLDivElement>;
function TableRow({ children, ...rest }: TableRowProps) {
  return <SummaryList.Row {...rest}>{children}</SummaryList.Row>;
}

type TableValueProps = PropsWithChildren & HTMLProps<HTMLDListElement>;
function TableValue({ children, ...rest }: TableValueProps) {
  return <SummaryList.Value {...rest}>{children}</SummaryList.Value>;
}

interface HighlightedTableComponent extends FC<PropsWithChildren> {
  HeaderValue: typeof TableHeaderValue;
  HeaderRow: typeof TableHeaderRow;
  Row: typeof TableRow;
  Value: typeof TableValue;
}

function HighlightedTable({ children, ...rest }: PropsWithChildren) {
  return <SummaryList className="highlighted-table" {...rest}>{children}</SummaryList>;
}

HighlightedTable.HeaderRow = TableHeaderRow;
HighlightedTable.HeaderValue = TableHeaderValue;
HighlightedTable.Row = TableRow;
HighlightedTable.Value = TableValue;

export default HighlightedTable as HighlightedTableComponent;
